import { api as documentsApi } from './auto-generated/documents'

documentsApi.enhanceEndpoints({
  endpoints: {},
})

export { documentsApi }
